<template>
  <app-tooltip
    v-if="stage"
    :content="t(`tool_stage.${stage}.tooltip`)"
    placement="top"
    variant="panel"
  >
    <app-badge
      class="cursor-pointer"
      :tone="stage === 'beta' ? 'info' : 'warning'"
      :label="t(`tool_stage.${stage}.label`)"
    />
  </app-tooltip>
</template>

<script setup>
  /* eslint-disable no-undef */
  // ToolStageBadge — "Alpha" / "Beta" chip for a tool, with a hover tooltip
  // explaining what the stage means. Driven by the `stage` field on the
  // tool's entry in `src/config/domain/toolKeys.js`.
  import AppBadge from '@/components/ui/feedback/AppBadge.vue';
  import AppTooltip from '@/components/ui/feedback/AppTooltip.vue';
  import { useI18n } from 'vue-i18n';

  defineProps({
    /** 'alpha' | 'beta'. Renders nothing when falsy. */
    stage: { type: String, default: '' },
  });

  const { t } = useI18n();
</script>
